import { FilterDocument, ID } from '@griply/types';
import { getCompletedDateGroupSettings } from '@griply/utils';
import React, { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { ProvidedTaskFilterList } from 'shared/views/task-filter-list';

import { CompletedEmptyState } from '../completed-empty-state';

const emptyOrder = {};

export type TasksOverviewProps = {
  scrollElement?: React.RefObject<HTMLDivElement>;
  filterDocument: FilterDocument;
  defaultFilter: FilterDocument;
  onSectionCollapse: (sectionIds: ID[]) => void;
  onReset: () => void;
};

export const TasksOverview: React.FC<TasksOverviewProps> = ({
  scrollElement,
  filterDocument,
  defaultFilter,
  onSectionCollapse,
  onReset,
}) => {
  const today = useToday();

  const groupSettings = useMemo(
    () => getCompletedDateGroupSettings(today),
    [today],
  );

  return (
    <ProvidedTaskFilterList
      filterDocument={filterDocument}
      defaultFilterDocument={defaultFilter}
      onSectionCollapse={onSectionCollapse}
      scrollElement={scrollElement}
      onReset={onReset}
      customOrder={emptyOrder}
      groupSettings={groupSettings}
      includeTaskWithAction
      EmptyState={CompletedEmptyState}
    />
  );
};
